module.exports = __webpack_public_path__ + "img/aiHello2.698133f7.png";